var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Cookies from 'js-cookie';
var Localstorage = /** @class */ (function () {
    function Localstorage() {
    }
    Localstorage.read = function (key) {
        if (window.localStorage) {
            return window.localStorage[key];
        }
        return null;
    };
    Localstorage.write = function (key, value) {
        if (window.localStorage) {
            window.localStorage[key] = value;
        }
    };
    return Localstorage;
}());
export { Localstorage };
export var cookie = function (key, value, option) {
    if (typeof value !== 'undefined') {
        Cookies.set(key, value, __assign(__assign({}, option), { samesite: 'None', secure: true }));
    }
    else {
        return Cookies.get(key);
    }
};
